import React from 'react';
import './Label.scss';
export type labelView = 'mfg-block' | 'mfg-inline';
export interface Props {
  LabelClass?: any,
  LabelId?: any,
  children?: any,
  Labelfor?: any,
  labelView?: labelView,
  style?: React.CSSProperties
}

const Label = ({
  LabelClass,
  LabelId,
  Labelfor,
  children,
  labelView = "mfg-inline",
  style
}:Props) => {
  return (
    <label style={style && style} className={`${labelView}${LabelClass ? (' '+LabelClass) : ''}`} id={LabelId} htmlFor={Labelfor}>
      {children}
    </label>
  )
}

export default Label
